<script setup lang="ts">
import { getApiRoot } from '~/utilities/api';
import { formatXchPrice } from '~/utilities/chia-display-utils';
import type { PropType } from 'vue';

const props = defineProps({
  offeredOrRequested: { type: Object as PropType<{ [assetId: string]: number }>, required: true },
});
const { offeredOrRequested } = toRefs(props);

const nfts = ref<{ [assetId: string]: any }>({});
for (const assetId of Object.keys(offeredOrRequested.value)) {
  if (assetId.startsWith('nft')) {
    nfts.value[assetId] = await $fetch<any>(`${getApiRoot()}/nfts/${assetId}`);
  }
}
</script>
<template>
  <div class="w-full">
    <!-- TODO Check whether a Nuxt upgrade fixes this-->
    <ClientOnly>
      <div v-for="[assetId, amount] in Object.entries(offeredOrRequested)" :key="assetId">
        <div v-if="assetId === 'xch'" class="flex items-center gap-1">
          <img class="h-5 w-5" src="/chia_circle.png" />
          {{ formatXchPrice(amount, true) }}
        </div>
        <NuxtLink :to="`/nfts/${assetId}`" v-else-if="assetId.startsWith('nft')" class="flex h-6 items-center gap-2">
          <img
            v-if="nfts[assetId]?.data?.thumbnail_uri"
            :src="nfts[assetId]?.data?.thumbnail_uri"
            loading="lazy"
            class="h-6 w-6 flex-shrink-0 rounded-md border object-cover object-center"
          />
          <span class="truncate">
            {{ nfts[assetId]?.data?.metadata_json?.name || assetId }}
          </span>
        </NuxtLink>
        <NuxtLink
          v-else
          target="_blank"
          :to="`https://dexie.space/assets/${assetId}`"
          class="inline-flex items-center gap-1 font-semibold text-neutral-700 dark:text-neutral-200"
        >
          <img class="h-6 w-6 rounded-full" :src="`https://icons.dexie.space/${assetId}.webp`" />{{ amount }}
        </NuxtLink>
      </div>
    </ClientOnly>
  </div>
</template>
